class VisantoNav extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.enableMobileSwitcher();
    this.setEventsOnAnhors();
  }

  setEventsOnAnhors() {
    const mainMenu = this.querySelector('#main-menu');
    if(!mainMenu) return;

    const rootMenuAnchors = this.querySelectorAll('.main-menu__anhor-with-list');
    const rootMenuAnchorLists = this.querySelectorAll('.main-menu__anhor-list')

    const removeHovered = () => {      
      const hoveredAnhors = mainMenu.querySelectorAll('.hovered');
      hoveredAnhors.forEach(h => h.classList.remove('hovered'));
    }

    mainMenu.addEventListener('click', (e) => {
      rootMenuAnchors.forEach(anchor => {
        if(anchor !== e.target) anchor.classList.remove('opened')
      })
      if(e.target.classList.contains('main-menu__anhor-with-list') && window.outerWidth < 1280) {
        e.preventDefault();
        e.target.classList.toggle('opened');
      }
    });

    rootMenuAnchorLists.forEach(submenu => {
      submenu.addEventListener('mouseleave', removeHovered)
    })

    mainMenu.addEventListener('mouseleave', removeHovered)
  }

  enableMobileSwitcher() {
    const mobileMenuToggle = document.querySelector('.menu-mobile-trigger');
    const announcementBars = document.querySelectorAll('announcement-bar');
    if(!mobileMenuToggle) return;

    mobileMenuToggle.addEventListener('click', () => {
      if (this.classList.contains("opened")) {
        this.classList.remove("opened");
        document.body.classList.remove("no-scroll");
        if (announcementBars) announcementBars.forEach(announcementBar => announcementBar.style.display = "");
      } else {
        this.classList.add("opened");
        document.body.classList.add("no-scroll");
        if (announcementBars) announcementBars.forEach(announcementBar => announcementBar.style.display = "none");
      }
    });
  }
}
customElements.define('visanto-nav', VisantoNav);